import { useEffect, useState } from "react";
import { Shield } from "lucide-react";

const links = [
  { label: "ABOUT", href: "#about" },
  { label: "SKILLS", href: "#skills" },
  { label: "LOGS", href: "#experience" },
  { label: "OPS", href: "#projects" },
  { label: "FIELD", href: "#field-work" },
  { label: "CERTS", href: "#certifications" },
  { label: "EDU", href: "#education" },
];

export default function Nav() {
  const [progress, setProgress] = useState(0);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const total = h.scrollHeight - h.clientHeight;
      const p = total > 0 ? (window.scrollY / total) * 100 : 0;
      setProgress(p);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    setOpen(false);
  };

  return (
    <nav
      data-testid="main-navigation"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-black/70 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-16 flex items-center justify-between">
        <a
          href="#top"
          onClick={(e) => scrollTo(e, "#top")}
          data-testid="nav-logo"
          className="flex items-center gap-2 group"
        >
          <Shield size={16} strokeWidth={1.5} className="text-[#00FF66]" />
          <span className="font-['JetBrains_Mono'] text-xs tracking-[0.25em] text-[#F5F5F5]">
            RA_SYS<span className="text-[#00FF66]">.</span>
          </span>
        </a>

        <ul className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <li key={l.label}>
              <a
                href={l.href}
                onClick={(e) => scrollTo(e, l.href)}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                className="link-underline font-['JetBrains_Mono'] text-[11px] tracking-[0.25em] text-[#A1A1AA] hover:text-[#F5F5F5]"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <a
          href="#contact"
          onClick={(e) => scrollTo(e, "#contact")}
          data-testid="nav-cta-initiate"
          className="hidden md:inline-flex items-center gap-2 border border-[#00FF66] text-[#00FF66] px-4 py-2 font-['JetBrains_Mono'] text-[11px] tracking-[0.25em] hover:bg-[#00FF66] hover:text-black transition-colors"
        >
          INITIATE <span className="cursor-blink">_</span>
        </a>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden font-['JetBrains_Mono'] text-xs text-[#00FF66] border border-[#00FF66] px-3 py-1"
          onClick={() => setOpen((o) => !o)}
        >
          {open ? "CLOSE" : "MENU"}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-black/90 backdrop-blur-xl">
          <ul className="flex flex-col px-6 py-4 gap-4">
            {links.map((l) => (
              <li key={l.label}>
                <a
                  href={l.href}
                  onClick={(e) => scrollTo(e, l.href)}
                  className="font-['JetBrains_Mono'] text-xs tracking-[0.25em] text-[#F5F5F5]"
                >
                  {l.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="#contact"
                onClick={(e) => scrollTo(e, "#contact")}
                className="inline-flex border border-[#00FF66] text-[#00FF66] px-4 py-2 font-['JetBrains_Mono'] text-[11px] tracking-[0.25em]"
              >
                INITIATE _
              </a>
            </li>
          </ul>
        </div>
      )}

      {/* Scroll progress indicator */}
      <div
        data-testid="nav-scroll-progress"
        className="absolute bottom-0 left-0 h-[2px] bg-[#00FF66]"
        style={{ width: `${progress}%`, transition: "width 0.08s linear" }}
      />
    </nav>
  );
}
